import { useEffect, useState } from "react";
import pinPoint from "../assets/pinPoint.png";
import { Link } from "react-router-dom";

const STORAGE_KEY = "sonaPromoShown";

export default function SonaPromoModal() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        // if (sessionStorage.getItem(STORAGE_KEY)) return;

        const timer = setTimeout(() => {
            setIsOpen(true);
            // sessionStorage.setItem(STORAGE_KEY, "true");
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    const closeModal = () => setIsOpen(false);

    const handleBookClick = () => {
        closeModal();
        setTimeout(() => {
            document.getElementById("formContatti")?.scrollIntoView({ behavior: "smooth" });
        }, 300);
    };

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
            onClick={closeModal}
        >
            <div
                className="relative w-full max-w-4xl min-h-[500px] bg-black overflow-visible rounded-md flex flex-col md:flex-row items-center"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={closeModal}
                    aria-label="Chiudi"
                    className="absolute top-4 right-4 text-white text-3xl leading-none z-50"
                >
                    &times;
                </button>

                <div className="relative z-10 flex flex-col gap-6 p-8 md:p-12 md:w-3/5 text-white">
                    <h2 className="text-3xl md:text-4xl font-extrabold uppercase text-balance">
                        Ora ci trovi anche a <em className="italic">Sona</em>!
                    </h2>

                    <p className="text-sm md:text-base  text-balance">
                        <strong>Da oggi Mcare raddoppia:</strong> <br /> siamo aperti anche a Sona (VR), in via Toscana, 13, proprio dietro il centro commerciale <em className="italic">La Grande Mela</em>.
                    </p>

                    <Link to="https://maps.app.goo.gl/xyPVjWf95XXx7KPA8" target="_blank" className="text-sm md:text-base w-1/2 uppercase font-bold underline hover:text-green-800">Vieni a trovarci!</Link>

                    <button
                        onClick={handleBookClick}
                        className="border border-white px-6 py-3 uppercase font-semibold tracking-wide w-fit hover:bg-white hover:text-black transition duration-300 ease-in-out"
                    >
                        Prenota ora una visita
                    </button>
                </div>

                <img
                    src={pinPoint}
                    alt="Mcare apre una nuova sede a Sona"
                    className="w-48 mt-4 md:mt-0 md:w-[40rem] max-w-none object-contain md:absolute md:-top-[85px] md:right-0 pointer-events-none select-none"
                />
            </div>
        </div>
    );
}
